import { call, put, spawn, take, all } from 'redux-saga/effects';

import quoteService from 'services/quoteService';
import supplierSettingsService from 'services/supplierSettingsService';

import {
  emailNotificationSettingsRetrieve,
  finalizeModalInit,
} from './actions';
import { types } from './actions';

function* watchFinalizeModalOpen() {
  for (;;) {
    const {
      payload: { quoteId, isResend },
    } = yield take(types.FINALIZE_MODAL_OPEN);
    try {
      const { quoteHeader, quoteItems } = yield all({
        quoteHeader: call(quoteService.getHeaderById, quoteId),
        quoteItems: call(quoteService.getQuoteItemHeadersById, quoteId),
      });
      const emailNotificationSettings = yield call(
        supplierSettingsService.getEmailNotificationSettings,
      );
      const { emailTemplates } = yield call(
        quoteService.getEmailTemplates,
        quoteId,
      );
      const shippingInfo = yield call(
        quoteService.getShippingInfoForFinalize,
        quoteId,
      );
      yield put(
        finalizeModalInit.success({
          emailNotificationSettings,
          emailTemplates,
          isResend,
          quoteHeader,
          quoteItems,
          shippingInfo,
        }),
      );
    } catch (error) {
      yield put(emailNotificationSettingsRetrieve.error());
    }
  }
}

export default function* root() {
  yield spawn(watchFinalizeModalOpen);
}
